import "./sass/app.scss";
import * as pages from "./js/pages/**/*.js";
import * as components from "./js/components/*.js";
import Theme from "./js/class/Theme";
import setProxy from "./js/utils/proxy";

const theme = new Theme("body");
const excluded = [ 'contact', 'client', 'KAFV5tlWlrUpSOSN', 'brief' ]
const slug = Array.from(document.querySelector("body").classList)
  .filter((c) => c.startsWith("u-page-"))[0]
  .split("-")[2];

const scroller = excluded.includes(slug) ? null : setProxy(".smooth-scroll");

pages[slug]?.index?.render({ theme, scroller });
Object.keys(pages[slug]?.components || {})
  ?.filter((key) => key[0] != "_") 
  .map((key) =>
    pages[slug]?.components[key].render({ theme, scroller })
  );
Object.keys(components)
  .filter((key) => key[0] != "_")
  .map((key) => components[key].render({ theme, scroller }));

sessionStorage.setItem("loaded", true);